// i18n
import translations from 'presentations/views/components/pages/DeveloperPage/i18n.json';
import { translateInComponent } from 'infras/i18n';

import { useContext } from 'react';

import MainDocument from 'presentations/views/components/MainDocument';
import DeveloperPage from 'presentations/views/components/pages/DeveloperPage';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import { getHomeSiteNavigationElement } from 'presentations/views/components/atoms/StructuredData';
import { webPath } from 'presentations/routes/path';
import { GetStaticPropsContext } from 'next';
import { developerCenterPath } from 'presentations/routes/path/developer';

interface ServerProps {
  linkCanonical: string;
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      linkCanonical: webPath(developerCenterPath(), locale),
    },
  };
}

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  return (
    <MainDocument
      title={t('title')}
      description={t('description')}
      linkCanonical={props.linkCanonical}
      isShowDownloadLink
      isExcludeSiteName
      structuredData={
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: getHomeSiteNavigationElement(),
          }}
        />
      }
    >
      <DeveloperPage viewer={viewer} />
    </MainDocument>
  );
}
